export class AppConsts {
    static  homeVideoUrl: string
    static  waitingScreenVideoUrl: string
    static  allowedFiles: string
    static  contactUsLink: string
    static  EMRandEMHLink: string
    static APILinkForDocument: string
  }
